import React, { forwardRef } from 'react'


const MenuItem = forwardRef((props, ref) => {
  const {
    onSelect, onClick, role = 'menuitem', state, setState,
    index, onKeyDown, _ref, ...rest
  } = props

  const isSelected = index === state.selectionIndex

  const setRef = (node) => {
    if (ref) {
      ref(node)
    }

    if (_ref) {
      _ref(node)
    }
  }

  const select = () => {
    if (onSelect) {
      onSelect()
    }

    setState({
      isOpen: false,
      selectionIndex: -1,
      closingWithClick: false,
    })
  }

  const handleClick = (event) => {
    if (onClick) {
      onClick(event)
    }

    select()
  }

  const handleKeyDown = (event) => {
    if (onKeyDown) {
      onKeyDown(event)
    }

    if (event.key === 'Enter') {
      // prevent the button from being "clicked" by
      // this "Enter" keydown
      event.preventDefault()
      select()
    }
  }

  return (
    <div
      {...rest}
      ref={setRef}
      role={role}
      tabIndex="-1"
      data-selected={role === 'menuitem' && isSelected ? true : undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    />
  )
})


export default MenuItem
